import { render, staticRenderFns } from "./genj.vue?vue&type=template&id=407869d1&scoped=true"
import script from "./genj.vue?vue&type=script&lang=js"
export * from "./genj.vue?vue&type=script&lang=js"
import style0 from "./genj.vue?vue&type=style&index=0&id=407869d1&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407869d1",
  null
  
)

export default component.exports